var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesfazer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1203 23.0001C19.7658 22.0599 20.2405 21.0633 20.5443 20.0103C20.8481 18.9573 21 17.8855 21 16.7949C21 15.3659 20.7243 13.9458 20.1729 12.5348C19.6215 11.1238 18.7959 9.87377 17.6962 8.78467C16.5965 7.69558 15.3524 6.88703 13.964 6.35903C12.5757 5.83103 11.1615 5.56779 9.72152 5.56929L11.8861 3.36929L9.49367 1.00006L3 7.37442L9.49367 13.7488L11.8861 11.3795L9.37974 8.8975C10.4051 8.8975 11.4494 9.09531 12.5127 9.49093C13.5759 9.88655 14.4873 10.4597 15.2468 11.2103C16.0063 11.9609 16.5858 12.8259 16.9853 13.8052C17.3848 14.7845 17.5838 15.7622 17.5823 16.7385C17.5823 17.3778 17.4972 18.0172 17.3271 18.6565C17.157 19.2958 16.9192 19.9163 16.6139 20.518L19.1203 23.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesfazer);
export default __webpack_public_path__ + "static/media/Desfazer.f45a60f14322d4ccb91170234b10a20f.svg";
export { ForwardRef as ReactComponent };